import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
@Component({
  selector: 'app-af-product-per-counter',
  templateUrl: './af-product-per-counter.component.html',
  styleUrls: ['./af-product-per-counter.component.scss'],
})
export class AfProductPerCounterComponent implements OnInit {

  @Input() brandList: any[];
  @Input() typeList: any[];
  @Input() categoryList: any[];
  @Input() listingStatus: any[];

  @Input() brandId: any;
  @Input() typeId: any;
  @Input() categoryId: any;
  @Input() listingStatusId: any;

  constructor(
    private modalController: ModalController
  ) { }

  ngOnInit() {}

  async dismissModal(code: any) {
    let dataReturn: any[] = [];
    if(code === 'search') {
      let data = {
        'brand_id': this.brandId,
        'type_id': this.typeId,
        'category_id': this.categoryId,
        'listing_status_id': this.listingStatusId
      };

      dataReturn.push(data);
    }

    if(code === 'close') {
      dataReturn = [];
    }
    
    await this.modalController.dismiss(dataReturn);
  }

  clearField() {
    this.brandId = undefined;
    this.typeId = undefined;
    this.categoryId = undefined;
    this.listingStatusId =undefined;
  }

}

